import initPaymentDrawerToggle from '../components/payment-drawer';

document.addEventListener('DOMContentLoaded', () => {
  // Initialise the payment options drawer toggle
  initPaymentDrawerToggle();
});
